export default __webpack_public_path__ + "static/media/credit-card.8f1aad81.svg";